module.exports = __webpack_public_path__ + "media/images/application2/AppEvents__hero__socials__a-bdf0e6d800d8c4aae052341c4dff2aae.svg";